import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { business, photos } from '../../data/site';
import { whatsappLink } from '../../utils/whatsapp';
export function Hero() {
  const {
    t
  } = useLanguage();
  const h = t.home.hero;
  const reduce = useReducedMotion();
  return <section className="relative isolate w-full overflow-hidden bg-ink" data-id="element-30" data-mp="aq4s6jw12tuv">
      <img src="https://cdn.magicpatterns.com/uploads/p28TTM9MTCBL6vMn52LGPb/Banner_Yeni.jpg" alt={h.imageAlt} className="absolute inset-0 h-full w-full object-cover object-[70%_center]" data-id="element-31" data-mp="5p79m673vxsu" />
      <div className="absolute inset-0 bg-ink/65 lg:hidden" aria-hidden="true" data-id="element-32" data-mp="3rxyqymwnftku" />
      <div className="absolute inset-0 hidden bg-[linear-gradient(90deg,rgba(46,36,48,0.92)_0%,rgba(46,36,48,0.78)_38%,rgba(46,36,48,0.15)_68%,rgba(46,36,48,0)_100%)] lg:block" aria-hidden="true" data-id="element-33" data-mp="1v4n90tv8a55j" />

      <div className="relative mx-auto flex min-h-[640px] max-w-7xl items-center px-5 py-20 sm:px-8 lg:min-h-[720px]" data-id="element-34" data-mp="1mvj9nnp7jhog">
        <motion.div className="max-w-xl" initial={reduce ? false : {
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-35" data-mp="1rtchsma2mlrd">
          <p className="text-xs font-medium uppercase tracking-wider2 text-champagne" data-id="element-36" data-mp="25n3svz3gadp7">{h.eyebrow}</p>
          <h1 className="mt-5 font-display text-4xl font-semibold leading-[1.08] text-white sm:text-5xl lg:text-6xl" data-id="element-37" data-mp="2alnh665io1kq">
            {h.title}
          </h1>
          <p className="mt-6 text-base leading-relaxed text-white/85 sm:text-lg" data-id="element-38" data-mp="1vwhgedr163aq">{h.subtitle}</p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center" data-id="element-39" data-mp="20uj276fucgpw">
            <a href={whatsappLink()} target="_blank" rel="noreferrer" className="flex h-14 items-center justify-center rounded-full bg-mauve px-8 text-sm font-medium text-white transition-colors duration-150 ease-smooth hover:bg-mauve-deep" data-id="element-40" data-mp="2ok50zssawtxd">
              {h.primary}
            </a>
            <Link to="/portfolio" className="flex h-14 items-center justify-center rounded-full border border-white/50 px-8 text-sm font-medium text-white transition-colors duration-150 ease-smooth hover:border-white hover:bg-white/10" data-id="element-41" data-mp="2u7gn4qvb5ydr">
              {h.secondary}
            </Link>
            <a href={business.phoneHref} className="flex h-14 items-center justify-center gap-2 px-2 text-sm font-medium text-white/90 transition-colors duration-150 ease-smooth hover:text-champagne" data-id="element-42" data-mp="2fhri2kk3ha87">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-43" data-mp="26g1i2qc5d2yt" />
              {h.call}
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}